import * as actionTypes from '../actionType';

export const getAllServicesAction =  () => ({
    type: actionTypes.FETCH_SERVICES,
});